import React from 'react';
import { useTranslation } from 'react-i18next';
import { Kanban, MonitorDown } from 'lucide-react';
import { DESKTOP_DOWNLOAD_URL, WEB_HOME_PANEL } from '../../platform/target';
import { setActiveTab } from '../../store/uiModalStore';
import './DesktopOnlyNotice.css';

/**
 * Shown on the web app (web.apiboo.com) in place of a page that only exists in
 * the desktop app (API client, DB Manager, Terminal, FTP/SFTP, Mail catcher) —
 * reached through a deep link, a shortcut or the command palette.
 */
export default function DesktopOnlyNotice() {
  const { t } = useTranslation();
  return (
    <div className="web-desktop-only" data-testid="desktop-only-notice">
      <div className="web-desktop-only__card">
        <span className="web-desktop-only__icon" aria-hidden>
          <MonitorDown size={26} />
        </span>
        <h2 className="web-desktop-only__title">{t('web.desktopOnly.title')}</h2>
        <p className="web-desktop-only__text">{t('web.desktopOnly.text')}</p>
        <div className="web-desktop-only__actions">
          <a className="web-desktop-only__btn web-desktop-only__btn--primary" href={DESKTOP_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer">
            <MonitorDown size={14} aria-hidden /> {t('web.desktopOnly.download')}
          </a>
          <button type="button" className="web-desktop-only__btn" onClick={() => setActiveTab(WEB_HOME_PANEL)}>
            <Kanban size={14} aria-hidden /> {t('web.desktopOnly.backToBoards')}
          </button>
        </div>
      </div>
    </div>
  );
}
